const ToBearMass=[
    // {
    //     id:1,
    //     title:"Корн Дог 400г/50г",
    //     isNew: true,
    //     price:"260 грн",
    //     src: require('../img/corndog.png'),
    //     text:"Картопля фрі, сосиски, кетчуп, солодкий чілі соус",
    // allergy: `🥚яйце,🌾глютен (паніровка)`
    // },
    // {
    //     id:2,
    //     title:"Курячі серця 300г",
    //     price:"240 грн",
    //     src: require('../img/kurSerd.png'),
    //     text:"Курячі серця, перець болгарський, шампіньйони, часник, петрушка, соєвий соус, лаваш",
    // isNew: true,
    // allergy: `🍄‍🟫гриби,🌱соя, 🌾глютен (лаваш)`
    // },
    {
        id:3,
        title:"бастурма 50г",
        price:"110 грн",
        src: require('../img/basturma.png'),
        text:"",
    },
    {
        id:4,
        title:"фісташки 50г",
        price:"100 грн",
        src: require('../img/fist.png'),
        text:"",
    allergy: `🌰 горіхи`
    },
    // {
    //     id:5,
    //     title:"Мюнхенські ковбаски 220г/50г",
    //     price:"179 грн",
    //     src:require('../img/munhenkovb.png'),
    //     text:"Ковбаски, чебрець, соус гірчичний",
    // },
    //{
        //id:6,
        //title:"Fish & Chips 300г/100г",
        //price:"224 грн",
        //src: require('../img/fishandchips.png'),
        //text:"Філе білої риби, темпура, картопля фрі, соус тар-тар, кетчуп, лимон",
    //},
    {
        id:7,
        title:"Цибулеві кільця 150г/50г",
        price:"160 грн",
        src: require('../img/lukkolca.png'),
        text:"Цибуля, паніровка, соус часниковий",
    allergy: `🌾глютен (паніровка), 🌶️гірчиця,🥚яйце`
    },
    
    //{
        //id:8,
        //title:"Крокети курячі 180г/50г",
        //price:"129 грн",
        //src: require('../img/kurikrocket.png'),
        //text:"філе куряче, паніровка, соус тар-тар",
    //},
    //{
        //id:9,
        //title:"Крокети м'ясні 180г/50г",
        //price:"185 грн",
        //src: require('../img/myaskrocket.png'),
        //text:"Ошийок свинячий, паніровка, цибуля, сосус BBQ",
    //},
    
    {
        id:10,
        title:"курка в'ялена 50г",
        price:"90 грн",
        src: require('../img/vyalkur.png'),
        text:"",
    },
    // {
    //     id:11,
    //     title:"свинина в'ялена 50г",
    //     price:"120 грн",
    //     src: require('../img/vyalsv.png'),
    //     text:"",
    // },
    // {
    //     id:12,
    //     title:"яловичина в'ялена 50г",
    //     price:"120 грн",
    //     src: require('../img/vyalgov.png'),
    //     text:"",
    // },
    // {
    //     id:13,
    //     title:"хамон 50г",
    //     price:"124 грн",
    //     src:require('../img/hamon.png'),
    //     text:"",
    // },
    {
        id:14,
        title:"«Поросячий вереск» 200г",
        price:"195 грн",
        src: require('../img/visk.webp'),
        text:"вуха копчені, обсмажені в соєвому соусі з перцем чилі, часником та соусом тобаско",
    allergy: `🌱соя`
    },
    {
        id:15,
        title:"Фірмові нагетси 150г/50г",
        price:"169 грн",
        src: require('../img/naget.webp'),
        text:"куряче філе в паніровці, медово - гірчичний соус",
    allergy: `🌾глютен (паніровка), 🥚яйце, 🍯мед,
🌶️ гірчиця `
    },
    {
        id:16,
        title:"Печериці фрі 180г/50г",
        price:"150 грн",
        src: require('../img/mush.webp'),
        text:"печериці в паніровці, тар-тар",
    allergy: `🍄‍🟫гриби, 🌾глютен (паніровка), 🥚яйце`
    },
    {
        id:17,
        title:"«Мюнхенські сухарики» 150г",
        price:"110 грн",
        src: require('../img/suh.webp'),
        text:"бородинський хліб, часниковий соус, майонез, сир",
    allergy: `🌾 глютен (хліб), 🥛 молоко (сир)🥚 яйце,🌶️гірчиця `
    },
    {
        id:18,
        title:"ORANGE-chips 70г",
        price:"94 грн",
        src: require('../img/chips.webp'),
        text:"чіпси з лаваша",
    allergy: `🌾глютен (лаваш)`
    },
    {
        id:19,
        title:"Медові крильця 350г",
        price:"190 грн",
        src: require('../img/fly.webp'),
        text:"крильця, медово-соєвий соус, кунжут",
    allergy: `🍯мед, 🌱соя, 🌰кунжут`
    },
    {
        id:20,
        title:"Мисливські ковбаски 250г",
        price:"155 грн",
        src: require('../img/soeg.webp'),
        text:"ковбаски, зелень",
    },
    {
        id:21,
        title:"Сир фрі 220г/50г",
        price:"170 грн",
        src: require('../img/cheesbeer.webp'),
        text:"сир моцарелла, паніровка, малиновий джем",
    allergy: `🥛 молоко (сир моцарела), 🌾 глютен (паніровка), 🥚 яйце`
    },
    {
        id:22,
        title:"кальмар темпура 100г/50г",
        price:"189 грн",
        src: require('../img/kalmar.webp'),
        text:"кальмар, темпра, соус тар-тар",
    allergy: `🦑кальмар,🌾 глютен (темпура), 🥚 яйце ,🍋цитрус `
    },
    {
        id:23,
        title:"тигрові креветки темпура 120г/50г",
        price:"295 грн",
        src: require('../img/tiger.webp'),
        text:"тигрові креветки, темпура, соус солодкий чілі, лимон",
    allergy: `🦐 креветки,🌾 глютен (темпура), 🥚 яйце`
    },
    {
        id:24,
        title:"дошка для компанії 1100г/150г",
        price:"820 грн",
        src: require('../img/doshkomp.webp'),
        text:"печериці фрі, мисливські ковбаски, нагетси, сир фрі, медові крильця, цибулеві кільця, соус кисло-солодкий, соус тар-тар, соус часниковий, соус медово-гірчичний",
    allergy: `🍄‍🟫 гриби , 🥛 молоко (сир), 🌾 глютен (паніровка, сухарики), 🥚 яйце, 🌱 соя,🌶️ гірчиця , 🍯 мед ,🌰 кунжут`
    },
    {
        id:25,
        title:"дошка під пиво 1000г/150г",
        price:"550 грн",
        src: require('../img/doskapodpivo.png'),
        text:"Orange chips, мюнхенські сухарики, печериці фрі, цибулеві кільця, картопля фрі, соус тартар, часниковий та кетчуп",
    allergy: `🌾 глютен (сухарики, паніровка, лаваш), 🥛 молоко (сир), 🥚 яйце,🍄‍🟫 гриби,🌶️гірчиця`
    },
    {
        id:26,
        title:"дошка м'ясна 1200г/150г",
        price:"880 грн",
        src: require('../img/myasnadoska.png'),
        text:"стейк зі свинини, медові крильця, нагетси, поросячий вереск, мисливські ковбаски, соус медово-гірчичний, bbq ,соус до мʼяса",
    allergy: `🌾 глютен (паніровка), 🥚 яйце,🌱 соя ,🌶️ гірчиця ,🍯 мед, 🌰кунжут`
    },
]


export default ToBearMass;